<mat-accordion>
  <mat-expansion-panel #filters [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Filtro por:
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="row pb-3" [formGroup]="formStart">
      <mat-form-field class="col-md-3">
        <mat-label>Tienda</mat-label>
        <mat-select id="entityProductivityPickingFilter" formControlName="entity" title="Picking"
          (selectionChange)="onChangeEntity()" multiple>
          <mat-option *ngFor="let item of entities" [value]="item.entityId">
            {{ item.entityName + '-' + item.entityCode}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <app-date-range class="col-md-3" [clearTrigger]="clearFlag" [label]="'Fecha de despacho'"
        (rangeChange)="onChangePeriod($event)">
      </app-date-range>
      
      <div class="col-md-6" style="padding-bottom: 1.25em;">
        <button id="btn-filter-productivity" type="button" class="button-success" mat-flat-button
          [disabled]="!formStart.valid" (click)="onClickFilter()">
          Aplicar
        </button>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>